/**
 * The cognito groups an administrator can assign or filter by, id -> display label.
 *
 * Single source of truth for the three pickers that used to each carry their own list and disagree:
 * UserView (assign a group), ProvidersView/ProviderView (a provider's groups), and UsersView (filter users
 * by group) — which was missing four of them, so users in those groups could be assigned but never found.
 *
 * `anonymous` is deliberately absent: it is a sentinel in the backend's `access.*` config meaning "no auth
 * required", never a real cognito group, so it must never be assignable.
 *
 * `auditors` is being renamed to `researchers` and is labelled deprecated until the old group is deleted from
 * cognito — remove it then. See docs/plans/group-rename-researchers.md
 */
export const GROUPS = {
    administrators: 'Administrators',
    support: 'Support',
    employer: 'Employers',
    providers: 'Providers',
    patients: 'Patients',
    experts: 'Experts',
    researchers: 'Researchers',
    auditors: 'Auditors (deprecated)',
    debug: 'Debug'
};

/** Group ids in display order. */
export const GROUP_IDS = Object.keys(GROUPS);
